import { useState } from "react";
import { useParams } from "@tanstack/react-router";
// Hooks
import { useCheckAPI } from "../../hooks/useCheckAPI";
// State
import { useReturnCard } from "../../state/returnCardState";
// Component imports
import { GenericListHeader } from "../../components/GenericHeader";
import { ReturnLines } from "./ReturnLines";
import { ReturnDetails } from "./ReturnDetails";
// MUI imports
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

export function ReturnOrderCompletedCard() {
  const [returnOrder, setReturnOrder] = useState({
    completedOrder: {},
    completedOrderLines: [],
  });

  const { id } = useParams({ strict: false });
  const { isPending, isError, isSuccess, error, data } = useReturnCard(id);

  // Success Function
  const successFunc = () => setReturnOrder(data.data.data.data.data);
  // Error Function
  const errorFunc = () =>
    console.warn(`Error: ${data.data.status}: ${data.data.statusText}`);
  // Hook to check the BC API for errors
  useCheckAPI(isSuccess, data, data?.data?.status, successFunc, errorFunc);

  return (
    <>
      {isError && <Typography>Error: {error.message}</Typography>}
      <Box>
        {returnOrder.completedOrder && (
          <Box>
            <GenericListHeader
              heading={`Return Order - ${returnOrder.completedOrder.no}`}
            />
            <Box sx={{ pt: 1 }}>
              <ReturnDetails returnOrder={returnOrder.completedOrder} />
            </Box>
          </Box>
        )}
      </Box>
      <Box>
        {returnOrder.completedOrderLines &&
        returnOrder.completedOrderLines.length !== 0 ? (
          <Box sx={{ pt: 1 }}>
            <ReturnLines returnLines={returnOrder.completedOrderLines} />
          </Box>
        ) : (
          !isPending && <Typography>No Data</Typography>
        )}
      </Box>
    </>
  );
}
